<!-- App.svelte -->
<script lang="ts">
  // Imports
  import Map from "./components/map/Map.svelte";
  import Legend from "./components/map/Legend.svelte";
  import SidePanel from "./components/general/SidePanel.svelte";
  import Logo from "./components/general/Logo.svelte";
  import License from "./components/general/License.svelte";
  import { licenseTermsAccepted } from "./stores/licenseStore";
  import { apiKey } from "./config";

  // Init
  let map;
</script>

<License />
<main class="dark {$licenseTermsAccepted ? '' : 'blurry'}">
  <Map {apiKey} bind:map />
  <SidePanel>
    <Logo slot="logo" logo="logo-light" width={"150px"} />
    <img slot="image" src="./data/brush_timmy2.png" alt="Timmy at Land's End" />
    <div id="title">
      <h3
        class="lead-in-subheading padded peckline-5 light {$licenseTermsAccepted
          ? ''
          : 'blurry'}"
      >
        Painting Utterly Brilliant Britain
      </h3>
      <h1 class="headline light {$licenseTermsAccepted ? '' : 'blurry'}">
        Timmy Mallett's
      </h1>
      <h2 class="headline-2 light {$licenseTermsAccepted ? '' : 'blurry'}">
        Cycling Circumnavigation of Great Britain
      </h2>
    </div>
    <h3
      id="story"
      class="lead-in-subheading light {$licenseTermsAccepted ? '' : 'blurry'}"
    >
      The origin story<span id="MallettArt" class="material-symbols-outlined">
        menu_book
      </span>
    </h3>
    <p class="light {$licenseTermsAccepted ? '' : 'blurry'}">
      This story starts over 200 years ago when Napoleon discouraged people from
      travelling to Europe, and artists like Joseph Turner set off to explore
      Britain with their sketchbooks.
    </p>
    <p class="light {$licenseTermsAccepted ? '' : 'blurry'}">
      I wanted to follow in their footsteps, exploring our beautiful coastline
      by bike and painting the adventure as I went. To this end, Ordnance Survey
      provided a
      <a
        href="https://shop.ordnancesurvey.co.uk/"
        target="_blank"
        rel="noreferrer">great range of maps</a
      >
      to help with planning and choosing good cycle routes.
    </p>
    <p class="light {$licenseTermsAccepted ? '' : 'blurry'}">
      This journey was actually further and took longer than I expected – I set off from Paddington Station down the Thames and headed clockwise around the coast keeping the sea on my left.
      <br /><br />
      4,500 miles later and pedalling for over 4 and half months I found myself back where I’d started 
    </p>
    <h3
      id="author"
      class="lead-in-subheading light {$licenseTermsAccepted ? '' : 'blurry'}"
    >
      ~ Timmy Mallett
    </h3>
    <Legend />
    <div
      class="paddedSmall peckline-5 light {$licenseTermsAccepted
        ? ''
        : 'blurry'}"
    > <span class="material-symbols-outlined"> palette </span>
    <div class="light {$licenseTermsAccepted
        ? ''
        : 'blurry'}">
     
      To view or buy Timmy's artwork, visit<a
      id="MallettArt"
      href="https://www.mallettspallette.co.uk/"
      target="_blank"
      rel="noreferrer">Mallett Fine Art</a
    >
      or find Timmy Mallett at his <a 
      href="https://linktr.ee/timmymallett" 
      target="_blank" 
      rel="noreferrer"> Linktree</a></div> </div>

    <p
      class="italics light {$licenseTermsAccepted
        ? ''
        : 'blurry'}">
      Thanks to OS Jamie Heath & Mel Marochov for developing the web map.
      </p>
    </SidePanel>
</main>

<style lang="scss">
  @import "./styles/style.scss";
  main {
    height: 100%;
    width: 100%;
  }

  #MallettArt {
    padding: 0 5px;
  }

  a {
    // color: $color-secondary-orange;
    text-decoration: underline;
  }

  img {
    margin-top: -40px;
    width: 100%;
  }

  #story {
    align-items: center;
    display: flex;
    justify-content: flex-start;
  }

  .padded {
    padding: 8px;
    align-items: center;
    display: flex;
    justify-content: flex-start;
  }

  .paddedSmall {
    padding: 4px;
    display: flex;
    align-items: center;
    margin: 20px 0;
  }

  #author {
    text-align: right;
    margin: 18px 0px;
  }

  h1 {
    margin: 15px 0px 15px 0px;
  }

  :global(.headline-2) {
    font-size: 22px;
    font-family: "OS Gill Regular", sans-serif;
  }

  .blurry {
    filter: blur(20px);
  }

  span {
    padding: 0 12px;
  }

  .italics {
    text-align: center;
    font-style: italic;
  }
</style>
